import { brgChipColorMapper, } from '@/components/Common/Chip.vue';
import { processType } from '@/constants/operationSetting/option';
import { i18n } from '@/locales';
const lc = 'views.operation_setting_history.';
export const historyTableHeader = [
    {
        // 처리과정
        title: i18n.t(`${lc}table.process_status`),
        align: 'center',
        sortable: false,
        value: 'processStatusChip',
        width: 98,
    },
    {
        // 설정대상
        title: i18n.t(`${lc}table.setting_target`),
        align: 'center',
        sortable: false,
        value: 'formattedSettingTarget',
        width: 142,
    },
    {
        // 설정유형
        title: i18n.t(`${lc}table.setting_type`),
        align: 'center',
        sortable: false,
        value: 'formattedSettingType',
        width: 142,
    },
    {
        // 내용
        title: i18n.t(`${lc}table.content`),
        align: 'center',
        sortable: false,
        value: 'formattedMemoContent',
        width: 260,
    },
    {
        // 처리자
        title: i18n.t(`${lc}table.processed_by`),
        align: 'center',
        sortable: false,
        value: 'formattedProcessedBy',
        width: 120,
    },
    {
        // 처리일시
        title: i18n.t(`${lc}table.processed_at`),
        align: 'center',
        sortable: false,
        value: 'formattedProcessedAt',
        width: 166,
    },
];
// https://www.figma.com/file/LC3qOpB2dbDWxR0ZiQEUl3/%5B%EA%B4%80%EC%A0%9C%5D-%EC%9A%B4%ED%96%89%EC%84%A4%EC%A0%95-%E2%98%81%EF%B8%8F?type=design&node-id=8716-430891&mode=dev
export const processStatusChipMapper = {
    // 본사확인중
    CHECKING: {
        color: brgChipColorMapper.green,
        text: i18n.t(`${lc}process_status.checking_at_headquarters`),
    },
    // 처리중
    IN_PROCESS: {
        color: brgChipColorMapper.blue,
        text: i18n.t(`${lc}process_status.in_process`),
    },
    // 처리완료
    COMPLETED: {
        color: 'blueGrey',
        text: i18n.t(`${lc}process_status.processing_completed`),
    },
    // 본사거절
    REFUSED: {
        color: brgChipColorMapper.red,
        text: i18n.t(`${lc}process_status.refused_at_headquaters`),
    },
};
export const settingTypeMapper = {
    // 설정할증 적용
    APPLY_CONFIG_SURCHARGE: {
        text: i18n.t(`${lc}setting_type.apply_config_surcharge`),
        value: processType.APPLY_CONFIG_SURCHARGE,
    },
    // 설정할증 해제
    RELEASE_CONFIG_SURCHARGE: {
        text: i18n.t(`${lc}setting_type.release_config_surcharge`),
        value: processType.RELEASE_CONFIG_SURCHARGE,
    },
    // 추가할증금액 변경
    CHANGE_IRREGULAR_SURCHARGE: {
        text: i18n.t(`${lc}setting_type.change_irregular_surcharge`),
        value: processType.CHANGE_IRREGULAR_SURCHARGE,
    },
    // 중단 적용
    PAUSE_DELIVERY: {
        text: i18n.t(`${lc}setting_type.pause_delivery`),
        value: processType.PAUSE_DELIVERY,
    },
    // 중단 해제
    ON_DELIVERY: {
        text: i18n.t(`${lc}setting_type.on_delivery`),
        value: processType.ON_DELIVERY,
    },
    // 지연시간 변경
    CHANGE_DELAY_TIME: {
        text: i18n.t(`${lc}setting_type.change_delay_time`),
        value: processType.CHANGE_DELAY_TIME,
    },
};
// 설정유형 v-select
export const settingTypeOptionList = Object.values({
    ALL: {
        text: i18n.t(`${lc}setting_type.all`),
        value: 'ALL',
    },
    ...settingTypeMapper,
});
// 설정유형 table
export const settingTypeTableOptionList = {
    ...settingTypeMapper,
    ETC: {
        text: i18n.t(`${lc}setting_type.etc`),
        value: 'ETC',
    },
};
// 이력 맵핑
// https://www.notion.so/barogohq/48c557f04c4d4b5bac323c29ae196f3f?v=f4ba07cd893647ea969b4e18a16d2676
export const historyMappingData = [
    {
        type: '[비가와서]',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: '[눈이와서]',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: '[심야할증]',
        text: i18n.t(`${lc}content.late_night`),
    },
    {
        type: '[주말할증]',
        text: i18n.t(`${lc}content.holiday`),
    },
    {
        type: '[기타]',
        text: i18n.t(`${lc}content.etc`),
    },
    {
        type: 'BAD_WEATHER',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: 'OVER_CAPACITY',
        text: i18n.t(`${lc}content.over_capacity`),
    },
    {
        type: 'RIDER_ACCIDENT',
        text: i18n.t(`${lc}content.rider_accident`),
    },
    {
        type: 'ETC',
        text: i18n.t(`${lc}content.etc`),
    },
    {
        type: 'WEATHER',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: 'LATE_NIGHT',
        text: i18n.t(`${lc}content.late_night`),
    },
    {
        type: 'BUSY',
        text: i18n.t(`${lc}content.busy`),
    },
    {
        type: 'HOLIDAY',
        text: i18n.t(`${lc}content.holiday`),
    },
    {
        type: 'AREA',
        text: i18n.t(`${lc}content.area`),
    },
    {
        type: 'TIME',
        text: i18n.t(`${lc}content.time`),
    },
    {
        type: 'OVERLOAD',
        text: i18n.t(`${lc}content.overload`),
    },
    {
        type: 'DISTANCE',
        text: i18n.t(`${lc}content.distance`),
    },
    {
        type: '콜 폭주',
        text: i18n.t(`${lc}content.over_capacity`),
    },
    {
        type: '기상 악화',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: '도로 결빙',
        text: i18n.t(`${lc}content.bad_weather`),
    },
    {
        type: '라이더 사고',
        text: i18n.t(`${lc}content.rider_accident`),
    },
    {
        type: '기타',
        text: i18n.t(`${lc}content.etc`),
    },
    {
        type: '바로고 컨텍센터에서 처리',
        text: i18n.t(`${lc}content.headquaters_handled`),
    },
    {
        type: '기사부족',
        text: i18n.t(`${lc}content.lack_of_riders`),
    },
    {
        type: '인원부족',
        text: i18n.t(`${lc}content.lack_of_riders`),
    },
];
